import { QueryClient } from '@tanstack/react-query';
import { clearMutationTracking } from './useLeadMessages';
import { clearConversationsCache } from './useConversations';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2, // 2 minutos
      gcTime: 1000 * 60 * 10,   // 10 minutos
      retry: (failureCount, error: any) => {
        // Não tentar novamente em erros definitivos de permissão ou não encontrado
        const status = error?.status || error?.response?.status;
        if (status === 401 || status === 403 || status === 404) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false, // Gerenciado explicitamente quando necessário
    },
  },
});

// Limpeza de cache de mensagens e conversas em caso de logout ou troca de tenant/loja
export function clearLeadMessagesCache(leadId?: string) {
  clearMutationTracking(leadId);
  if (leadId) {
    queryClient.removeQueries({ queryKey: ['leads', leadId, 'messages'] });
    queryClient.setQueryData(['leads', leadId, 'messages'], () => undefined);
  } else {
    queryClient.removeQueries({ queryKey: ['leads'] });
    clearConversationsCache(queryClient);
  }
}

